"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketDocument = exports.TicketMessage = exports.Ticket = void 0;
class Ticket {
}
exports.Ticket = Ticket;
class TicketMessage {
}
exports.TicketMessage = TicketMessage;
class TicketDocument {
}
exports.TicketDocument = TicketDocument;
